// extracted by mini-css-extract-plugin
export var compactFilters = "_jd-4";
export var detailImage = "_jd-1";
export var dropdownContainer = "_jd-2";
export var imageContainer = "_jd-0";
export var selectedCard = "_jd-3";